/** Next.js 16 mounts dev tools inside a closed shadow root on this host. */
export const NEXT_DEV_PORTAL_TAG = "nextjs-portal";

export const DEV_TOOLS_HIDE_STYLE_ID = "voiceai-hide-next-devtools";

export const DEV_TOOLS_HIDE_CSS = `
${NEXT_DEV_PORTAL_TAG} {
  display: none !important;
  visibility: hidden !important;
  pointer-events: none !important;
}
`;

declare global {
  interface Window {
    __voiceaiDevToolsHidden?: boolean;
    __voiceaiSetNextDevToolsHidden?: (hidden: boolean) => void;
  }
}

/** Runs in <head> before React so login/guests never flash the dev badge. */
export const DEV_TOOLS_HIDE_BOOTSTRAP = `(function () {
  var HIDE_ID = ${JSON.stringify(DEV_TOOLS_HIDE_STYLE_ID)};
  var CSS = ${JSON.stringify(DEV_TOOLS_HIDE_CSS)};
  function setHidden(hidden) {
    window.__voiceaiDevToolsHidden = hidden;
    var el = document.getElementById(HIDE_ID);
    if (hidden) {
      if (!el) {
        el = document.createElement("style");
        el.id = HIDE_ID;
        el.textContent = CSS;
        (document.head || document.documentElement).appendChild(el);
      }
      document.querySelectorAll(${JSON.stringify(NEXT_DEV_PORTAL_TAG)}).forEach(function (node) {
        node.style.setProperty("display", "none", "important");
        node.style.setProperty("visibility", "hidden", "important");
        node.style.setProperty("pointer-events", "none", "important");
      });
    } else {
      el && el.remove();
      document.querySelectorAll(${JSON.stringify(NEXT_DEV_PORTAL_TAG)}).forEach(function (node) {
        node.style.removeProperty("display");
        node.style.removeProperty("visibility");
        node.style.removeProperty("pointer-events");
      });
    }
  }
  window.__voiceaiSetNextDevToolsHidden = setHidden;
  setHidden(true);
  new MutationObserver(function () {
    if (window.__voiceaiDevToolsHidden) setHidden(true);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();`;

export function setNextDevToolsHidden(hidden: boolean): void {
  if (typeof window === "undefined") return;
  window.__voiceaiSetNextDevToolsHidden?.(hidden);
}
